import { axiosInstance, type CustomResponseFormat } from "api/instance";
import { axiosInstancePromotion } from "./instancePromotion";

export const PAYMENT_DOMAIN = "payment";
export const PAYMENT_DOMAIN_V2 = "payment/v2";
export const PAYMENT_ORDER_DETAIL_ENDPOINT = "order/detail";
export const PAYMENT_PLAN_UPGRADE_ORDER_DETAIL_ENDPOINT =
  "plan-upgrade/order/detail";
export const PAYMENT_TOSSPAYMENTS_CONFIRM_ENDPOINT = "toss-payments/success";
export const PAYMENT_TOSSPAYMENTS_PLAN_UPGRADE_CONFIRM_ENDPOINT =
  "toss-payments/plan-upgrade/success";
export const PAYMENT_TOSSPAYMENTS_PROMOTION_CONFIRM_ENDPOINT =
  "toss-payments/promotion/success";
export const PAYMENT_STORE_REVIEWER_CONFIRM_ENDPOINT = "store-reviewer/confirm";
export const PAYMENT_COACH_SEAT_COUNT_ENDPOINT = "coach-seat/count";

interface Offer {
  identifier: string;
  keyIdentifier: string;
  nonce: string;
  signature: string;
  timestamp: number;
}

export interface PaymentOrderType {
  productId: string;
  isFirst: boolean;
  paymentProvider: "in_app" | "toss_payments";
  offerId?: string;
  offer?: Offer;
  firstMonthOfferLinkIos?: string;
  // tosspayments
  customerKey?: string;
  customerName?: string;
  customerId?: string;
  customerEmail?: string;
  orderId?: string;
  orderName?: string;
  price?: number;
  isStoreReviewer?: boolean;
  promotionType?: "book";
  pricingModel?: string;
  isCarePass?: boolean;
  isRestartRestricted?: boolean;
  hasUsedRefundGuarantee?: boolean;
  firstPaymentPageViewAt?: string;
  currentPaymentPageViewerCount?: number;
  cancelableAmount?: number;
  // 제휴 결제 할인: 활성 여부 + 마감 시각(epoch millis, 결제페이지 최초 진입 후 24h)
  affiliateDiscountActive?: boolean;
  affiliateDiscountExpiresAt?: number;
}

export interface PaymentPlanUpgradeOrderType {
  customerKey: string;
  customerName: string;
  customerId: string;
  customerEmail: string;
  orderId: string;
  orderName: string;
}

export interface CoachSeatCountType {
  countRemainCoachSeat: number;
}

export interface PageViewerCountType {
  countPageViewer: number;
}

export interface TossPaymentsConfirmType {
  orderId: string;
  paymentKey: string;
  payAmount: number;
  version?: string;
}

export interface TossPaymentsPlanUpgradeConfirmType {
  orderId: string;
  paymentKey: string;
  payAmount: number;
  previousPlan: string;
  newPlan: string;
  isCoachChangeRequested: boolean;
}

export interface TossPaymentsConfirmResponseType {
  isConfirmed: boolean;
  failureMessage?: string;
}

export interface StoreReviewerConfirmType {
  orderId?: string;
}

export interface CompanyMemberConfirmType {
  orderId?: string;
}

export const paymentApi = {
  getOrderDetail: () =>
    axiosInstance.get<CustomResponseFormat<PaymentOrderType>>(
      `${PAYMENT_DOMAIN}/${PAYMENT_ORDER_DETAIL_ENDPOINT}`
    ),

  getPlanUpgradeOrderDetail: () =>
    axiosInstance.get<CustomResponseFormat<PaymentPlanUpgradeOrderType>>(
      `${PAYMENT_DOMAIN}/${PAYMENT_PLAN_UPGRADE_ORDER_DETAIL_ENDPOINT}`
    ),

  confirmTossPayments: (body: TossPaymentsConfirmType) =>
    axiosInstance.post<CustomResponseFormat<TossPaymentsConfirmResponseType>>(
      `${PAYMENT_DOMAIN}/${PAYMENT_TOSSPAYMENTS_CONFIRM_ENDPOINT}`,
      body
    ),

  confirmTossPaymentsPlanUpgrade: (body: TossPaymentsPlanUpgradeConfirmType) =>
    axiosInstance.post<CustomResponseFormat<TossPaymentsConfirmResponseType>>(
      `${PAYMENT_DOMAIN}/${PAYMENT_TOSSPAYMENTS_PLAN_UPGRADE_CONFIRM_ENDPOINT}`,
      body
    ),

  confirmTossPaymentsPromotion: (body: TossPaymentsConfirmType) =>
    axiosInstancePromotion.post<
      CustomResponseFormat<TossPaymentsConfirmResponseType>
    >(
      `${PAYMENT_DOMAIN_V2}/${PAYMENT_TOSSPAYMENTS_PROMOTION_CONFIRM_ENDPOINT}`,
      body
    ),
  confirmStoreReviewer: (body: StoreReviewerConfirmType) =>
    axiosInstance.post<CustomResponseFormat>(
      `${PAYMENT_DOMAIN}/${PAYMENT_STORE_REVIEWER_CONFIRM_ENDPOINT}`,
      body
    ),

  countRemainCoachSeat: () => {
    return axiosInstance.get<CustomResponseFormat<CoachSeatCountType>>(
      `${PAYMENT_DOMAIN}/${PAYMENT_COACH_SEAT_COUNT_ENDPOINT}`
    );
  },
};
